// This file will be used for environment-specific settings that need to be
// available during build time. Most settings should be in config.json.
export const environment = {
  production: false
};
// CI/CD trigger - 1760977923
